// extracted by mini-css-extract-plugin
export default {"title":"styles_title__o1Pcq","wrapper":"styles_wrapper__-NGuX","buttons":"styles_buttons__NWpE9","backButton":"styles_backButton__DTXYC"};